//Hamburger and close btn functionality
const menuBtn = document.getElementById("menuBtn");
const mainMenu = document.getElementById("mainMenu");
const closeBtn = document.getElementById("closeBtn");
const menuOverlay = document.getElementById("menuOverlay");

if (menuBtn && mainMenu && closeBtn && menuOverlay) {
    menuBtn.addEventListener("click", e => {
       mainMenu.classList.toggle("is-active");
       menuOverlay.classList.toggle("is-active");
    })

    closeBtn.addEventListener("click", e=> {
        mainMenu.classList.toggle("is-active");
        menuOverlay.classList.toggle("is-active");

    })
}
